import bgImage from '../../assets/moneybank.png' 

export default function About(){
    return(
        <section
        className="about-section pt-120 pb-120 bg_img"
        data-background={bgImage}
      >
        <div className="container">
          <div className="row">
         <div className='col-md-6'>
            {/* <img style={{marginLeft:'20%', marginRight:'25%' , marginTop:'-50px'}} width={'70%'} src={bgImage} alt='..' /> */}
            <iframe src="https://app.vectary.com/p/1e8UtgqYjeQ1Yhd02sQR6N" frameborder="0" width="100%" height="480"></iframe>
            </div>
         {/* offset-lg-6 */}
            <div className="col-md-6 ">
              <div className="about-content">
                <h2 className="section-title mb-3">
                  <span className="font-weight-normal">About</span>{" "}
                  <b className="base--color">Us</b>
                </h2>
                <p>
                  We are an international financial company engaged in investment
                  activities, which are related to trading on financial markets and
                  cryptocurrency exchanges performed by qualified professional
                  traders.
                </p>
                <p className="mt-4">
                  Our goal is to provide our investors with a reliable source of high
                  income, while minimizing any possible risks and offering a
                  high-quality service, allowing us to automate and simplify the
                  relations between the investors and the trustees. We work towards
                  increasing your profit margin by profitable investment. We look
                  forward to you being part of our community.
                </p>
                <a href="#0" className="cmn-btn mt-4">
                  MORE INFO
                </a>
              </div>
              {/* about-content end */}
            </div>
          </div>
        </div>
      </section>      
    );
}